import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { AuthGuard } from "./shared/services";
import {
  UserListComponent,
  ActivityListComponent
} from "./monitoringScreens/index";

const routes: Routes = [
  {
    path: "login",
    loadChildren: () =>
      import("./authentication/authentication.module").then(
        (x) => x.AuthenticationModule
      ),
  },
  {
    path: "",
    canActivate: [AuthGuard],
    canActivateChild: [AuthGuard],
    loadChildren: () =>
      import("./navigation/navigation.module").then((x) => x.NavigationModule),
  },
  // {
  //   path: "service",
  //   component: UsersMonitoringDetailsComponent,
  // },
  // {
  //   path: "service",
  //   component: UsersMonitoringDetailsComponent,
 // },
  {
    path: "user-list",
    component: UserListComponent,
  },
  {
    path: "activity-list",
    component: ActivityListComponent,
  },
  {
    path: "**",
    redirectTo: "",
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class RoutingModule {}
